import { FC } from 'react';
import StudentList from './StudentList';
import UseStudentList from './UseStudentList';

const StudentListContainer: FC = () => {
  return <StudentList {...UseStudentList()} />;
};

export default StudentListContainer;
